export const RECEIVE_NOTIFICATION = "RECEIVE_NOTIFICATION ";
export const REMOVE_NOTIFICATION  = "REMOVE_NOTIFICATION";
export const READ_NOTIFICATION = "READ_NOTIFICATION";
export const NOTIFICATION_IS_READ = "NOTIFICATION_IS_READ";
export const REQUEST_NOTIFICATION = "REQUEST_NOTIFICATION";
export const LOAD_NOTIFICATION = "LOAD_NOTIFICATION";